<h1 mat-dialog-title>
  <mat-icon class="dialog-header-icon"
            svgIcon="gitlab"></mat-icon>
  <span>{{T.F.GITLAB.DIALOG_INITIAL.TITLE|translate}}</span>
</h1>

<form (submit)="saveGitlabCfg(gitlabCfg)"
      [formGroup]="formGroup">
  <mat-dialog-content>
    <formly-form (modelChange)="gitlabCfg=$event"
                 [fields]="formConfig"
                 [form]="formGroup"
                 [model]="gitlabCfg">
    </formly-form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button (click)="close()"
            color="primary"
            mat-button
            type="button">
      {{T.G.CANCEL|translate}}
    </button>

    <button [disabled]="!formGroup.valid"
            color="primary"
            mat-stroked-button
            type="submit">
      <mat-icon>save</mat-icon>
      {{T.G.SAVE|translate}}
    </button>
  </mat-dialog-actions>
</form>
